module.exports = "/packs/images/svg/weekly-prog/loading~0a04168b09f038429531c26b162d2e5f.svg";